"use client";
import React from "react";
import { useRouter, useSearchParams } from "next/navigation";
import Toast from "@/components/primitives/toast";
import { ToastProvider } from "@/components/primitives/toast";
import Icon from "@/components/primitives/icon";

export default function UnsubscribedToast() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (searchParams.get("unsubscribed") === "true") {
      setIsOpen(true);
    }
  }, [searchParams]);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      const url = new URL(window.location.href);
      url.searchParams.delete("unsubscribed");
      router.replace(
        url.pathname + (url.search ? `?${url.searchParams}` : ""),
        { scroll: false }
      );
    }
  };

  return (
    <ToastProvider>
      <Toast.Content open={isOpen} onOpenChange={handleOpenChange}>
        <div className="flex items-center gap-4 px-6 py-4 pr-10">
          <Icon
            name="checkmark"
            className="fill-success-300 color-success-300"
            size="lg"
          />
          You have successfully unsubscribed
        </div>
      </Toast.Content>
    </ToastProvider>
  );
}
